import { validateSymbolMarkup } from '#pplx/frontend/aether/primitives/IconPrimitive/validateSymbolMarkup.js';
const VALIDATION_CACHE_MAX = 2000;
const validationCache = new Map();
/**
 * Fail-closed gate for rendering fetched symbol markup. Aether/Icon is a
 * public render path, so the primitive cannot assume callers only feed it
 * first-party endpoint data: anything outside the sprite grammar — scripts,
 * event handlers, foreignObject, unknown attributes — renders nothing. On
 * pass the original string is injected verbatim; validation never transforms
 * it. Verdicts are memoized per payload.
 */
export function isRenderableSymbol(icon) {
    if (typeof DOMParser === 'undefined') {
        return false;
    }
    const cacheKey = JSON.stringify([icon.id, icon.symbol]);
    const cached = validationCache.get(cacheKey);
    if (cached !== undefined) {
        return cached;
    }
    const valid = validateSymbolMarkup(icon);
    if (validationCache.size >= VALIDATION_CACHE_MAX) {
        validationCache.clear();
    }
    validationCache.set(cacheKey, valid);
    return valid;
}
//# sourceMappingURL=isRenderableSymbol.js.map